import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown } from 'react-bootstrap-5';
import { omit } from 'lodash';

export default class ActionsDropdown extends React.Component {
  static propTypes = {
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    selectedId: PropTypes.number,
    onAddToGroup: PropTypes.func.isRequired,
    onCreateGroup: PropTypes.func.isRequired,
    onDeleteFromGroup: PropTypes.func.isRequired
  };

  render() {
    const dropdownProps = omit(this.props, Object.keys(ActionsDropdown.propTypes));
    return (
      <Dropdown className="actions-dropdown borderless" id="actions-dropdown" {...dropdownProps}>
        <Dropdown.Toggle variant="ghost">
            Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <>
            <Dropdown.Item key="create-group" onClick={this.props.onCreateGroup}>Create Group</Dropdown.Item>
          </>
          {this.renderAddToGroupSection()}
          {this.renderDeleteFromGroupSection()}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderAddToGroupSection() {
    const {
      groups,
      selectedId,
      onAddToGroup
    } = this.props;

    if (groups && groups.length > 0) {
      let groupOptions = groups.map((group) => {
        const ids = group.personIds;
        if (!(ids.some(id=> selectedId === id))) {
          return (
            <Dropdown.Item
              eventKey={group}
              key={group.id}
              onSelect={onAddToGroup}
            >
              {group.name}
            </Dropdown.Item>
          );
        }
      });
      groupOptions = groupOptions.filter(Boolean);

      if (groupOptions.length > 0) {
        return (
          <>
            <Dropdown.Divider />
            <Dropdown.Header>Add to Group</Dropdown.Header>
            {groupOptions}
          </>
        );
      }
    }
  }

  renderDeleteFromGroupSection() {
    const {
      groups,
      selectedId,
      onDeleteFromGroup
    } = this.props;

    if (groups && groups.length > 0) {
      const groupOptions = groups.map((group) => {
        const ids = group.personIds;
        if (ids.some(id=> selectedId === id)) {
          return (
            <Dropdown.Item
              eventKey={group}
              key={group.id}
              onSelect={onDeleteFromGroup}
            >
              {group.name}
            </Dropdown.Item>
          );
        }
      });

      if (groupOptions.filter(Boolean).length > 0)
        return (
          <>
            <Dropdown.Divider />
            <Dropdown.Header>Delete from Group</Dropdown.Header>
            {groupOptions}
          </>
        );
    }
  }
}
